import { createContext } from "react"

export default createContext({
    open() {},
    close() {},
})